module.exports = __webpack_public_path__ + "static/media/ECI88_Copy.50e184a3.png";